import React, { Component } from 'react';
import DropDown2 from './DropDown2'

const meterApiValues = ["W", "G", "E", "B", "O" ];
const meterDisplay = [ "Water", "Gas", "Electric", "BTU", "Other" ]

export default class MeterDropdown extends Component {
  constructor(props) {
    super(props);

    this.apiValues = meterApiValues
    this.state = {
      options: meterDisplay,
    }
  }
  render () {
    const dd2 = MeterTypeDisplay (this.props?.value)
    return <DropDown2 {...this.state} {...this.props} value={dd2}
        onUpdate={(param)=>this.props.onUpdate (this.apiValues[param], this.props)}/>
  }
}
export function MeterTypeDisplay (apiValue) {
  apiValue = apiValue ?? ''
  const found = meterApiValues.indexOf(apiValue)
  return found < 0 ? (apiValue ? apiValue : "Not Available") : meterDisplay[found]
}
